@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/border-style";

web-chatbot {
    height: max-content;
    display: flex;
    flex-direction: column;
    --web-chatbot-desktop-vp: #{breakpoints.$screen-xl-min};

    .chatbot-container {
        border: border-width.$lg solid color.$color-background-200;
        border-radius: border-radius.$xl border-radius.$xl 0 0;
    }

    .chatbot-overlay {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;

        @media (min-width: breakpoints.$screen-md-min) {
            max-height: 65vh;
        }
    }

    .chatbot-button {
        width: 5rem;
        height: 5rem;
        position: fixed;
        bottom: 10rem;
        right: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: color.$color-primary;
        border: border-width.$md border-style.$solid color.$color-white;
        border-radius: 50%;
        padding: 0;
        color: color.$color-white;
        cursor: pointer;

        &.mobile-menu {
            bottom: 1rem;
        }

        @media (min-width: breakpoints.$screen-xl-min) {
            width: 6.5rem;
            height: 6.5rem;
        }

        @media (min-width: breakpoints.$screen-xl-min) {
            bottom: 1.8rem;
        }

        web-icon {
            --icon-height: #{size.$icon-lg};
            --icon-width: #{size.$icon-lg};

            @media (min-width: breakpoints.$screen-xl-min) {
                --icon-height: #{size.$icon-xl};
                --icon-width: #{size.$icon-xl};
            }
        }
    }

    web-chatbot-list {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }
    .chatbot-input-area {
        flex: 0 0 auto;
        margin-top: auto;
        background-color: color.$color-background-200;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        gap: spacing.$lg;
        padding: spacing.$lg;

        @media (min-width: breakpoints.$screen-md-min) {
            gap: spacing.$xl;
        }

        [slot="footer"] {
            text-align: center;
            --left-gutter: 0;
        }

        .color-primary {
            color: color.$color-primary;
        }
    }

    .dialog-actions {
        display: flex;
        justify-content: space-between;
        padding: spacing.$xl;
    }
}
